import Mask from "./components/Mask";
import SideBar from "./components/SideBar";
import LogoUTP from "assets/img/utp-logo.svg";
import LogoEPG from "assets/img/utp-logo-epg.svg";
import LogoutMenu from "./components/LogoutMenu";
import UserProfile from "./components/UserProfile";
import useHeaderBase from "./hooks/useHeaderBase";
import { Icon } from "@utp/react-components-prod";

const HeaderBase = () => {
  const {
    user,
    logoutRef,
    isRoleEPG,
    isActiveMenu,
    isMinorTablet,
    tabIndexValue,
    isActiveHeader,
    isActiveLogout,
    setIsActiveMenu,
    handleLogoutClick,
    setIsActiveLogout,
    handleRedirectToSummary,
  } = useHeaderBase();

  return (
    <header
      role="banner"
      className={` ${
        isActiveHeader ? "flex" : "hidden"
      } justify-between items-center bg-01 px-8 py-5 relative`}
    >
      <Mask isActiveMenu={isActiveMenu} />

      <SideBar
        isActiveMenu={isActiveMenu}
        setIsActiveMenu={setIsActiveMenu}
        handleLogoutClick={handleLogoutClick}
        user={user}
      />
      <button
        className={`bg-grey-90 absolute h-full w-56 left-0 cursor-pointer items-center justify-center ${
          isMinorTablet ? "flex" : "hidden"
        }`}
        onClick={() => setIsActiveMenu(!isActiveMenu)}
        data-testid="btn-menu-open"
        aria-label={isActiveMenu ? "Cerrar menú" : "Abrir menú"}
        aria-expanded={isActiveMenu ? "true" : "false"}
      >
        <Icon iconName="menu" className="mr-2 text-white" size={20} />
      </button>
      <button
        aria-hidden="false"
        tabIndex={tabIndexValue}
        aria-label="Volver al inicio"
        data-testid="btn-home"
        onClick={handleRedirectToSummary}
        className={`border-2 border-white focus:border-primary-60 rounded-md p-1 ${
          isMinorTablet ? "hidden" : ""
        }`}
      >
        <img
          src={isRoleEPG ? LogoEPG : LogoUTP}
          alt="Logo de la Universidad Tecnológica de Perú"
          width="auto"
          height="auto"
        />
      </button>
      {!isMinorTablet && (
        <div className="flex relative">
          <UserProfile user={user} />
          <div ref={logoutRef} className="flex items-center">
            <LogoutMenu
              tabIndexValue={tabIndexValue}
              isActiveLogout={isActiveLogout}
              setIsActiveLogout={setIsActiveLogout}
              onLogout={handleLogoutClick}
            />
          </div>
        </div>
      )}
    </header>
  );
};

export default HeaderBase;
